// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2XVb7","emails":"CreateEditClinics_emails__2qfuz","emailTagLabel":"CreateEditClinics_emailTagLabel__1WQhj"};